import Vue from 'vue'
import { messageBox, message } from '@/utils/msg'
Vue.prototype.$msgB = messageBox
Vue.prototype.$msg = message



// WEBPACK FOOTER //
// ./src/plugins/msg.js